//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmCityList from 'vue-baidu-map/components/controls/CityList.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue';
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue';
import { project_list } from '@/api/pests';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      morevalue: [{
        "name_cn": "张三",
        "value": 1
      }],
      refresh_valueData: [{
        name: "10" + this._vm.$t('秒'),
        value: 10
      }, {
        name: "15" + this._vm.$t('秒'),
        value: 15
      }, {
        name: "30" + this._vm.$t('秒'),
        value: 30
      }, {
        name: "1" + this._vm.$t('分钟'),
        value: 60
      }, {
        name: "5" + this._vm.$t('分钟'),
        value: 300
      }, {
        name: "10" + this._vm.$t('分钟'),
        value: 600
      }, {
        name: "15" + this._vm.$t('分钟'),
        value: 900
      }, {
        name: "30" + this._vm.$t('分钟'),
        value: 1800
      }, {
        name: "60" + this._vm.$t('分钟'),
        value: 3600
      }],
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      formModel: {
        refresh_value: 300
      },
      formRules: {
        refresh_value: [{
          required: true,
          type: "number",
          message: '采样频率不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    projectCode: {},
    morevalue: {}
  },
  components: {
    BaiduMap: BaiduMap,
    BmGeolocation: BmGeolocation,
    BmCityList: BmCityList,
    BmMarker: BmMarker,
    BmLabel: BmLabel,
    BmLocalSearch: BmLocalSearch
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: {},
  mounted: function mounted() {
    //debugger
    if (this.edit) {
      if (this.setData) {
        //console.log('a',this.setData)
        //alert()
        // Object.assign(this.formModel,this.setData)
        this.$set(this.formModel, 'morevalue', this.morevalue); //this.$set(this.formModel, 'allocation_code', this.setData.allocation_code)
        // console.log('b',this.formModel) 
      }
    }
  },
  created: function created() {//this.init()
  }
};